/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 */
import type { Props } from './../types/types';

import React from 'react';

const Touchable = (props: Props) => {
   if (!props) props = {};

   props = {
      className: 'touchable',
      children: null,
      style: null,
      onPress: null,
      onMouseEnter: null,
      onPressCancel: null,
      onMouseLeave: null,
      onPressIn: null,
      onPressOut: null,
      onMove: null,
      ...props
   };

   return (
      <div
         className={props.className}
         style={props.style}
         onClick={props.onPress}
         onMouseEnter={props.onMouseEnter}
         onMouseOut={props.onPressCancel}
         onMouseLeave={props.onMouseLeave}
         onMouseDown={props.onPressIn}
         onMouseUp={props.onPressOut}
         onMouseMove={props.onMove}
         onTouchStart={props.onPressIn}
         onTouchMove={props.onMove}
         onTouchEnd={props.onPressOut}
         onTouchCancel={props.onPressCancel}
      >
         {props.children}
      </div>
   );
};

export default React.memo(Touchable);
